import { render, staticRenderFns } from "./backdrop.vue?vue&type=template&id=4f56c726&scoped=true&"
import script from "./backdrop.vue?vue&type=script&lang=js&"
export * from "./backdrop.vue?vue&type=script&lang=js&"
import style0 from "./backdrop.vue?vue&type=style&index=0&id=4f56c726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56c726",
  null
  
)

export default component.exports